// src/pages/WelfareSupport.tsx
import React from 'react';
import CategoryPage from './CategoryPage';

const WelfareSupport: React.FC = () => <CategoryPage categoryId="welfare" art="family" />;

export default WelfareSupport;
